var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadges(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.66981C5.66981 5.66981 9.91509 4.39623 13.3113 1C16.7075 4.39623 20.9528 5.66981 25.6226 5.66981C25.6226 5.81132 25.6226 5.81132 25.6226 5.95283C25.6226 8.07547 25.6226 10.0566 25.6226 12.1792C25.6226 14.7264 25.3396 17.1321 24.7736 19.6792C23.6415 23.783 21.2358 27.0377 17.5566 29.1604C16.283 30.0094 14.8679 30.5755 13.4528 31C13.3113 31 13.1698 31 13.1698 31C11.0472 30.2925 8.92453 29.1604 7.22642 27.7453C4.67925 25.7642 2.98113 23.217 1.99057 20.1038C1.28302 17.9811 1 15.8585 1 13.7358C1 11.0472 1 8.5 1 5.81132C1 5.81132 1 5.66981 1 5.66981Z",
    stroke: "#3361CF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12.9961L10.75 20.4961L7 17.087",
    stroke: "#3361CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadges);
export default __webpack_public_path__ + "static/media/Badges.63ee90c1c541016e8775c7600f8f54e8.svg";
export { ForwardRef as ReactComponent };